/**
 * Composable for global search functionality with keyboard listeners
 * Allows typing anywhere on the page to filter products (when not in input fields)
 */
export function useGlobalSearch(searchModal?: Ref<boolean>) {
  const commerceStore = useCommerceStore()

  onMounted(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      // Ignore if user is typing in an input, textarea, or contenteditable
      const target = event.target as HTMLElement
      if (
        target.tagName === 'INPUT'
        || target.tagName === 'TEXTAREA'
        || target.isContentEditable
        || searchModal?.value // Ignore if modal is open
      ) {
        return
      }

      // Ignore modifier keys, special keys, and shortcuts
      if (
        event.ctrlKey
        || event.metaKey
        || event.altKey
        || event.key.length > 1 // Ignore special keys like Enter, Tab, Arrow keys, etc.
      ) {
        return
      }

      // Add typed character to search term
      if (event.key === ' ' || (event.key.length === 1 && event.key.match(/[a-zA-Z0-9]/))) {
        event.preventDefault()
        commerceStore.searchTerm += event.key
      }
    }

    const handleBackspace = (event: KeyboardEvent) => {
      // Only handle backspace when not in an input
      const target = event.target as HTMLElement
      if (
        target.tagName === 'INPUT'
        || target.tagName === 'TEXTAREA'
        || target.isContentEditable
        || searchModal?.value
      ) {
        return
      }

      if (event.key === 'Backspace' && commerceStore.searchTerm) {
        event.preventDefault()
        commerceStore.searchTerm = commerceStore.searchTerm.slice(0, -1)
      }
    }

    window.addEventListener('keypress', handleKeyPress)
    window.addEventListener('keydown', handleBackspace)

    onUnmounted(() => {
      window.removeEventListener('keypress', handleKeyPress)
      window.removeEventListener('keydown', handleBackspace)
    })
  })
}
